import React from 'react';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import styles from './blacklist-table.module.less';
import { messages } from './messages';

export const BlacklistTableEmptyRow = () => {
  return (
    <FlexColumn className={styles['empty-row']}>
      <Text textType={TextType.H4} value={messages.noEntriesTitle} />
      <Text textType={TextType.Description} value={messages.noEntriesDescription} />
    </FlexColumn>
  );
};
